// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Field, change, formValueSelector } from 'redux-form';
import InputField from '../../../customFields/InputField';
import EINDisplayControlField from './EINDisplayControlField';
import normalizeEIN from '../../../../../../utils/reduxForm/normalize/EIN';
import normalizeSSN from '../../../../../../utils/reduxForm/normalize/SSN';

const selector = formValueSelector('contractorTaxInformationReduxForm');

const TINSection = ({ profile, change, isEINDisplayed, initialValues }) => {
    const [init, setInit] = useState(false);

    useEffect(() => {
        if (isEINDisplayed) {
            if (init) {
                change('contractorTaxInformationReduxForm', 'nameAssociatedWithTIN', '');
            } else {
                setInit(true);
            }
        } else {
            change('contractorTaxInformationReduxForm', 'nameAssociatedWithTIN', profile.name);
        }
    }, [isEINDisplayed]);

    const normalize = (value) => (isEINDisplayed ? normalizeEIN(value) : normalizeSSN(value));

    const clearOnFocus = (event, name) => {
        if (event.target.value === initialValues[name])
            change('contractorTaxInformationReduxForm', name, '');
    };

    return (
        <div className="form_section">
            <div className="modal_title">Part I: Taxpayer Identification Number (TIN)</div>
            <div className="modal_subtitle">
                Enter your TIN in the appropriate box. The TIN provided must match the name
                given on the "Name" line to avoid backup withholding. For individuals, this is
                your SSN. For other entities, it is your EIN.
            </div>
            <div className="section_title">
                Note: If the account is in more than one name, see the chart on page 4.
            </div>

            <div className="field_row certification_modal__ein-row">
                <div className="modal_subtitle certification_modal__ein-question">
                    Do you have an Employer Identification Number (EIN)?:
                    {!isEINDisplayed && (
                        <>
                            <br />
                            Full name associated with TIN: {profile?.name}
                        </>
                    )}
                </div>
                <div className="radio_block horizontal">
                    <Field
                        name="isEINDisplayed"
                        component={EINDisplayControlField}
                        type="checkbox"
                    />
                </div>
            </div>

            <div className="address_section">

                <div className="field_row">
                    {isEINDisplayed && (
                        <>
                            <div  className="field_name">
                                <label>
                                    Company name associated with TIN:*
                                </label>
                             </div>
                            <div className="field_block">
                                <Field
                                    name="nameAssociatedWithTIN"
                                    component={InputField}
                                    type="text"
                                    required
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="field_row">
                    <div className="field_name">
                        <label>Business Name:*</label>
                    </div>
                    <div className="field_block">
                        <Field
                            name="businessName"
                            component={InputField}
                            type="text"
                            required
                        />
                    </div>
                </div>

                <div className="field_row">
                    <div className="field_name">
                        <label>{isEINDisplayed ? 'EIN' : 'SSN'}:*</label>
                        <div className="field_hint">
                            {isEINDisplayed ? '(xx-xxxxxxx)' : '(xxx-xx-xxxx)'}
                        </div>
                    </div>
                    <div className="field_block">
                        <Field
                            name={isEINDisplayed ? 'EIN' : 'SSN'}
                            component={InputField}
                            type="text"
                            normalize={normalize}
                            onFocus={clearOnFocus}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    profile: state.profile,
    isEINDisplayed: selector(state, 'isEINDisplayed'),
});

export default connect(mapStateToProps, { change })(TINSection);
